import React from "react";
import VideoContainer from "../VideoContainer";

const CourseVideos = ({ content, playVideo, hasAccess }) => {
  return (
    <>
      {content.map((video) => (
        <VideoContainer
          key={video.title}
          content={video}
          playVideo={playVideo}
          hasAccess={hasAccess}
        >
          {video.title}
        </VideoContainer>
      ))}
    </>
  );
};

export default CourseVideos;
